import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { init as initSentry } from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { AppConfigFactory } from './app/app.config';
import { AppConfig } from './app/core/types/app-config';
import { environment } from './environments/environment';

fetch(environment.configPath)
  .then(res => res.json())
  .then((config: AppConfig) => {
    if (environment.production) {
      enableProdMode();
      initSentry({
        dsn: "https://e64e114de7de1bbf08fd649c6980f089@o4506144349618176.ingest.us.sentry.io/4511693312753664",
        release: config.VERSION,
        environment: config.SENTRY_ENVIRONMENT,
      })
    }
    return bootstrapApplication(AppComponent, AppConfigFactory(config));
  })
  .catch(err => console.error(err));
